import { ModalPaymentConfirmation } from '@lideralia/alife-uikit/dist/organisms/Modals/PaymentConfirmation';
import React from 'react';

export const LoadingTemplate = (props) => <ModalPaymentConfirmation {...props} />;
